import { render, staticRenderFns } from "./SellerList.vue?vue&type=template&id=13a72ef1&scoped=true&"
import script from "./SellerList.vue?vue&type=script&lang=js&"
export * from "./SellerList.vue?vue&type=script&lang=js&"
import style0 from "./SellerList.vue?vue&type=style&index=0&id=13a72ef1&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../../home/ubuntu/albert_frontend/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "13a72ef1",
  null
  
)

export default component.exports